<div class="premiit_chip" [style.height.rem]="chipHeight" [style.width.rem]="chipWidth">
  <img class="premitt_chip--image"
    src="assets/images/premiit-monw.svg"
    alt="premiit-chip" loading="lazy"
    [style.height.rem]="logoHeight"
    [style.width.rem]="logoWidth">
</div>